export const SET_BREEDS = 'SET_BREEDS';
export const SET_SUBBREEDS = 'SET_SUBBREEDS';
export const SET_ALL = 'SET_ALL';
export const SET_LOADING_OFF = 'SET_LOADING_OFF';
export const SET_LOADING_ON = 'SET_LOADING_ON';
export const SET_IMAGES = 'SET_IMAGES';
export const CLEAR_BREEDS_IMAGES = 'CLEAR_BREEDS_IMAGES';
export const CLEAR_SUBBREEDS_IMAGES = 'CLEAR_SUBBREEDS_IMAGES';
export const HANDLE_ALL = 'HANDLE_ALL'
export const HANDLE_BREEDS = 'HANDLE_BREEDS'
export const HANDLE_SUBBREEDS = 'HANDLE_SUBBREEDS'
export const CLEAR_LIST = 'CLEAR_LIST'
export const FILTER_LIST = 'FILTER_LIST'
export const SET_BREED_SELECTED = 'SET_BREED_SELECTED'
export const CLEAR_FILTER = 'CLEAR_FILTER'
export const SET_CAROUSEL = 'SET_CAROUSEL'

